import { createSelector } from "@reduxjs/toolkit";

import { isOnsiteUpsellBuilder } from "@src/store/slices/experienceBuilder/common/selectors/isOnsiteUpsellBuilder";
import {
  FEATURED_IDEA_IDS,
  ONSITE_UPSELL_FEATURED_IDEAS,
} from "@src/store/slices/experienceBuilder/ideas/data";
import { ideasSlice } from "@src/store/slices/experienceBuilder/ideas/slice";
import type { Idea } from "@src/store/slices/experienceBuilder/ideas/types";

const { getIdeas } = ideasSlice.selectors;

/**
 * The ideas shown as chips in the chat empty state. Onsite-upsell chats show
 * their own upsell chips; every other experience uses `FEATURED_IDEA_IDS` from
 * the catalog, in order. Keyed off the builder mode (`openedAsOnsiteUpsell`),
 * not `experience.type`, so a personalization opened as an upsell still gets
 * the upsell chips. Memoized for referential stability.
 */
export const getFeaturedIdeas = createSelector(
  [getIdeas, isOnsiteUpsellBuilder],
  (ideas, isOnsiteUpsell) => {
    if (isOnsiteUpsell) return ONSITE_UPSELL_FEATURED_IDEAS;
    const byId = new Map(ideas.map((idea) => [idea.id, idea]));
    return FEATURED_IDEA_IDS.map((id) => byId.get(id)).filter(
      (idea): idea is Idea => idea !== undefined
    );
  }
);
